import ClientMainLayout from '@client/composition/main-layout/application/layout/ClientMainLayout.vue';
import { messagingRoutes } from '@client/feature/messaging/application/routes/messaging.routes';
import { attendeeManagementRoutes } from '@client/feature/attendee-management/application/routes/attendee-management.routes';
import { communicationKitRoutes } from '@client/feature/communication-kit/application/routes/communication-kit.routes';
import { gameDetailRoutes } from '@client/feature/game-detail/application/routes/game-detail.routes';
import { usageDataRoutes } from '@client/feature/usage-data/application/routes/usage-data.routes';
import { establishmentRoutes } from '@client/feature/establishment/application/routes/establishment.routes';
import { createRouter, createWebHistory } from 'vue-router';
import { globalGuard } from '@client/composition/router/application/routes/global.route-guard';
import { redirectToDefaultLandingOnInfiniteLoopNavigationError } from '@shared/feature/landing/application/helper/redirect-to-default-landing-on-infinite-loop-navigation-error.helper';
import { landingRoutes } from '@shared/feature/landing/application/routes/landing.routes';
import { homeRoutes } from '@client/feature/home/application/routes/home.routes';
import { redirectToClientPath } from '@client/common/router/application/helper/redirect-to-client-path.helper';
import { loginRoutes } from '@client/feature/login/application/routes/login.routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...loginRoutes,
    ...landingRoutes,
    {
      // The client app canonical URL is /client, but the historical entry point is /.
      // Keep / as an entry point while normalizing the visible URL.
      path: '/',
      redirect: redirectToClientPath,
    },
    {
      // Old client deep links used to live at the domain root. Redirect them before
      // guards run so the app does not bootstrap protected pages outside /client.
      path: '/:legacyClientRoute(login|communication-kit|messaging|attendees|usages|games)/:legacyPathMatch(.*)*',
      redirect: redirectToClientPath,
    },
    {
      path: '/client',
      component: ClientMainLayout,
      name: 'cockpit',
      children: [
        ...homeRoutes,
        ...messagingRoutes,
        ...attendeeManagementRoutes,
        ...establishmentRoutes,
        ...communicationKitRoutes,
        ...usageDataRoutes,
        ...gameDetailRoutes,
      ],
    },
  ],
});

router.onError((error) => redirectToDefaultLandingOnInfiniteLoopNavigationError(router, error));

router.beforeEach(globalGuard);

export default router;
